import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import LeadModal from "./LeadModal.jsx";

const ConfirmDialog = ({ isOpen, title, message, confirmLabel = "Confirm", loading = false, onConfirm, onCancel }) => (
  <LeadModal
    isOpen={isOpen}
    onClose={onCancel}
    title={title}
    size="sm"
    disableClose={loading}
    footer={
      <>
        <button type="button" className="lm-btn lm-btn--ghost" onClick={onCancel} disabled={loading}>
          Cancel
        </button>
        <button type="button" className="lm-btn lm-btn--danger" onClick={onConfirm} disabled={loading}>
          {loading ? <><span className="lm-spinner" /> Please wait...</> : confirmLabel}
        </button>
      </>
    }
  >
    <div className="lm-confirm">
      <span className="lm-confirm-icon"><FiAlertTriangle size={22} /></span>
      <p>{message}</p>
    </div>
  </LeadModal>
);

export default ConfirmDialog;
